import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-panel-expandable',
    templateUrl: './panel-expandable.component.html',
    styleUrls: ['./panel-expandable.component.scss'],
    standalone: false
})
export class PanelExpandableComponent {
	@Input() text: any;
	@Input() description: any;
	@Input() body: TemplateRef<any>;
	@Input() fixed: boolean;
	@Input() expanded = true;
	@Input() required = false;
	@Input() width = '30rem';
	@Input() tooltip: string;
	@Input() enabled = true;
	@Input() overlayTooltip = "";
}
